import React, { useEffect, useState } from "react";
import Sidebar from "../Sidebar/Sidebar";
import Navbar from "./Navbar";
import Header from "./header";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import ApiConfig from "../../common/config/ApiConfig";
import { useLanguage } from "../../common/i18n/LanguageContext";

const LIMIT = 10;

function AgentTopupReport() {
  const { t } = useLanguage();
  const pos = localStorage.getItem("position");
  const user = localStorage.getItem("user");

  const [agentOptions, setAgentOptions] = useState([]);
  const [selectedAgent, setSelectedAgent] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [currencyCodeById, setCurrencyCodeById] = useState({});

  useEffect(() => {
    ApiConfig.get("/getCurrencyList").then((result) => {
      if (result.resCode !== 200) return;
      const list = Array.isArray(result.data) ? result.data : [];
      setCurrencyCodeById(Object.fromEntries(list.map((c) => [c.id, c.code])));
    });
  }, []);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    ApiConfig.get(`/getdownline?user=${encodeURIComponent(user)}`).then(
      (result) => {
        if (result.resCode !== 200) {
          toast.error(result.message || t("common_load_error"), {
            position: "top-right",
            autoClose: 3000,
          });
          return;
        }
        const list = Array.isArray(result.data) ? result.data : [];
        const uniqueByUsername = Array.from(
          new Map(list.map((item) => [item.username, item])).values(),
        );
        setAgentOptions(uniqueByUsername);
      },
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchData = (currentPage = 1) => {
    const params = new URLSearchParams({ page: currentPage, limit: LIMIT });
    if (selectedAgent) params.set("agent", selectedAgent);
    if (fromDate) params.set("fromDate", fromDate);
    if (toDate) params.set("toDate", toDate);
    ApiConfig.get(`/getagenttopupreport?${params.toString()}`).then(
      (result) => {
        if (result.resCode !== 200) {
          toast.error(result.message || t("common_load_error"), {
            position: "top-right",
            autoClose: 3000,
          });
          return;
        }
        setData(Array.isArray(result.data) ? result.data : []);
        setPage(currentPage);
        if (result.total != null) setTotal(result.total);
      },
    );
  };

  useEffect(() => {
    fetchData(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const totalPages = total > 0 ? Math.ceil(total / LIMIT) : 0;

  return (
    <div className="h-screen flex flex-col overflow-hidden">
      <div className="shrink-0">
        <Navbar />
      </div>
      <div className="flex flex-1 overflow-hidden items-start">
        <div className="shrink-0 overflow-y-auto h-full">
          <Sidebar pos={pos} />
        </div>
        <div className="flex flex-col flex-1 max-h-full overflow-hidden">
          <div className="shrink-0">
            <Header title={t("menu_agenttopup_report")} />
          </div>
          <div className="flex-1 overflow-y-auto p-2">
            <div className="p-2 bg-amber-50 border-[1px] border-slate-400 rounded-lg mb-2 text-sm">
              <div className="flex flex-row flex-wrap items-center gap-4">
                <div className="flex flex-row items-center gap-2">
                  <label className="font-bold">{t("table_from_date")}</label>
                  <input
                    type="date"
                    value={fromDate}
                    onChange={(e) => setFromDate(e.target.value)}
                    className="p-1 border border-gray-300 rounded"
                  />
                </div>

                <div className="flex flex-row items-center gap-2">
                  <label className="font-bold">{t("table_to_date")}</label>
                  <input
                    type="date"
                    value={toDate}
                    onChange={(e) => setToDate(e.target.value)}
                    className="p-1 border border-gray-300 rounded"
                  />
                </div>

                <div className="flex flex-row items-center gap-2">
                  <label className="font-bold">{t("winlose_col_agent")}</label>
                  <select
                    value={selectedAgent}
                    onChange={(e) => setSelectedAgent(e.target.value)}
                    className="p-1 border border-gray-300 rounded"
                  >
                    <option value="">{t("common_all")}</option>
                    {agentOptions.map((opt) => (
                      <option key={opt.username} value={opt.username}>
                        {opt.username}
                      </option>
                    ))}
                  </select>
                </div>

                <button
                  onClick={() => fetchData(1)}
                  className="py-1 px-3 bg-brand-blue-700 hover:bg-brand-blue-800 text-white font-bold rounded text-sm"
                >
                  {t("common_search")}
                </button>
              </div>
            </div>

            <div className="rounded overflow-hidden mt-1 overflow-x-auto">
              <table className="w-full text-[14px] border-collapse whitespace-nowrap">
                <thead>
                  <tr className="bg-gray-100">
                    <th className="p-2 text-center border-b" width="50">
                      {t("membertable_col_no")}
                    </th>
                    <th className="p-2 text-left border-b">
                      {t("membertopupreport_col_date")}
                    </th>
                    <th className="p-2 text-left border-b">
                      {t("agenttopupreport_col_sender")}
                    </th>
                    <th className="p-2 text-left border-b">
                      {t("winlose_col_agent")}
                    </th>
                    <th className="p-2 text-right border-b">
                      {t("membertable_col_credit")}
                    </th>
                    <th className="p-2 text-left border-b">
                      {t("membertable_tx_col_ip")}
                    </th>
                    <th className="p-2 text-left border-b">
                      {t("membertable_tx_col_device")}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {data.length === 0 ? (
                    <tr>
                      <td colSpan={7} className="p-4 text-center text-gray-400">
                        {t("common_no_data")}
                      </td>
                    </tr>
                  ) : (
                    data.map((row, index) => (
                      <tr key={row.id} className="border-b hover:bg-gray-50">
                        <td className="p-2 text-center text-gray-500">
                          {(page - 1) * LIMIT + index + 1}
                        </td>
                        <td className="p-2">
                          {moment(row.date_time).format("DD/MM/YYYY HH:mm")}
                        </td>
                        <td className="p-2">{row.Sender ?? "-"}</td>
                        <td className="p-2">{row.Reciever ?? "-"}</td>
                        <td className="p-2 text-right">
                          {Number(row.Amout).toLocaleString()}{" "}
                          {currencyCodeById[row.currency_id]}
                        </td>
                        <td className="p-2">{row.ip ?? "-"}</td>
                        <td className="p-2">
                          <span
                            className="block truncate max-w-[200px]"
                            title={row.device ?? ""}
                          >
                            {row.device ?? "-"}
                          </span>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>

            {(totalPages > 1 || data.length > 0) && (
              <div className="flex items-center justify-between mt-3 px-2">
                <span className="text-sm font-semibold text-brand-blue-700 bg-brand-blue-50 px-3 py-1 rounded-full border border-brand-blue-200">
                  {t("commission_page_label")} {page}
                  {totalPages > 0 ? ` / ${totalPages}` : ""}
                  {total > 0 && ` · ${total} ${t("common_items_unit")}`}
                </span>
                <div className="flex space-x-1">
                  <button
                    onClick={() => fetchData(1)}
                    disabled={page === 1}
                    className="px-2 py-1 text-sm font-bold rounded bg-gray-200 text-gray-700 hover:bg-gray-300 disabled:opacity-30 disabled:cursor-not-allowed transition-colors"
                  >
                    «
                  </button>
                  <button
                    onClick={() => fetchData(Math.max(1, page - 1))}
                    disabled={page === 1}
                    className="px-3 py-1 text-sm font-medium rounded bg-brand-blue-100 text-brand-blue-700 hover:bg-brand-blue-200 disabled:opacity-30 disabled:cursor-not-allowed transition-colors"
                  >
                    ‹ {t("common_page_previous")}
                  </button>
                  <span className="px-3 py-1 text-sm font-bold rounded bg-brand-blue-600 text-white select-none">
                    {page}
                  </span>
                  <button
                    onClick={() => fetchData(page + 1)}
                    disabled={totalPages > 0 && page >= totalPages}
                    className="px-3 py-1 text-sm font-medium rounded bg-brand-blue-100 text-brand-blue-700 hover:bg-brand-blue-200 disabled:opacity-30 disabled:cursor-not-allowed transition-colors"
                  >
                    {t("common_next")} ›
                  </button>
                  {totalPages > 0 && (
                    <button
                      onClick={() => fetchData(totalPages)}
                      disabled={page >= totalPages}
                      className="px-2 py-1 text-sm font-bold rounded bg-gray-200 text-gray-700 hover:bg-gray-300 disabled:opacity-30 disabled:cursor-not-allowed transition-colors"
                    >
                      »
                    </button>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default AgentTopupReport;
